"use strict";

let empty_url = window.location.protocol + '//' + window.location.host + window.location.pathname;
let url_string = window.location.href;
let url = new URL(url_string);
let is_search_check = url.searchParams.get("s");
let page_num = url.searchParams.get( 'pages' );
let ajaxPostsPage = 0;
let more_than_one_page = false;


$(function () {
    $('#read-more').click(function (event) {
        if (page_num !== null && ajaxPostsPage == 0){
            ajaxPostsPage = page_num;
            more_than_one_page = true;
        }
        event.preventDefault();
        let el = $(this);
        let url = el.data('link');
        let cat = el.data('cat');
        let year = el.data('year');
        el.addClass('loading');
        $.post(url, {
            action: 'more_post_ajax',
            page: ++ajaxPostsPage,
            cat: cat,
            year: year,
            more_than_one_page: more_than_one_page,
            search_keyword: is_search_check
        }, function (response) {
            if(response !== '') {
                if (is_search_check){
                    history.replaceState( null, null, empty_url + '?s=' + is_search_check + '&pages=' + ajaxPostsPage );
                    more_than_one_page = false;
                }
                $('.ajax-posts').append(response);
                el.removeClass('loading');
            }
            if($('.has-more-posts:last').data('val') === 'no') {
                el.empty().remove();
            }
        });
    });
    $('#get-more-photo').click(function (event) {
        event.preventDefault();
        let el = $(this);
        let url = el.data('link');
        let type = el.data('type');
        el.addClass('loading');
        $.post(url, {
            action: 'more_gallery_ajax',
            page: ++ajaxPostsPage,
            type: type
        }, function (response) {
            if(response !== '') {
                $('.art-wrap').append(response);
                el.removeClass('loading');
            }
            if($('.has-more-posts:last').data('val') === 'no') {
                el.empty().remove();
            }
        });
    });

    /** narrow table fix **/

    $('table.narrow-table').each(function () {
        $(this).wrap('<div class="narrow-table"/>');
    })
});


// WEBPACK FOOTER //
// ./js/dev/posts.js